import * as React from "react";
import { useState, useEffect } from "react";
import { Snackbar, IconButton, Alert, Tooltip } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers-pro/AdapterDayjs";
import { DateRangePicker } from "@mui/x-date-pickers-pro/DateRangePicker";
// import { DataGridPro } from '@mui/x-data-grid-pro';
import { useGridApiRef } from '@mui/x-data-grid-pro';
import ControlledDataGrid from '../../../components/DataGrid/ControlledDataGrid';
import { OfficeLocationFilter, ProgramFilter, ReportFilterBar } from '../ReportFilters';
import moment from "moment";
import axios from "axios";
import { APIURL } from "../../../config";
import dayjs from "dayjs";

export default function CMCustomerNotesReport(props) {
    const [gridId, setGridId] = useState(64);
    const apiRef = useGridApiRef();

    const [isLoading, setIsLoading] = useState(true);
    const [customerNotesData, setCustomerNotesData] = useState([]);
    const [startDate, setStartDate] = useState(moment().startOf('month'));
    const [endDate, setEndDate] = useState(moment().endOf('month'));
    const [reportDetails, setReportDetails] = useState({});
    const [isFavorite, setIsFavorite] = useState(false);
    const [successText, setSuccessText] = useState("");
    const [errorText, setErrorText] = useState("");
    const [selectedOffice, setSelectedOffice] = useState(null);
    const [selectedProgram, setSelectedProgram] = useState(null);

    useEffect(() => {
        fetchData();
    }, []);

    const fetchData = async () => {
        setIsLoading(true);
        axios
            .get(APIURL + "/jsreport/getAllReports", {
                params: { empID: props.user.emp_id },
            })
            .then((response) => {
                const report = response?.data?.reports.find((ele) => ele.report_name === "Employee Notes Report");
                setReportDetails(report);
                setIsFavorite(report ? (report.status === 1 ? true : false) : false);
            });

        let customerNotesData = await axios.get(APIURL + "/customers/getAssociatedCustomersAndTaskNotes", {
            params: {
                compID: props.comp_id,
                empID: props.user.emp_id,
                empType: props.user.type,
                start: moment(startDate).startOf("day").format("YYYY-MM-DDTHH:mm:ss"),
                end: moment(endDate).endOf("day").format("YYYY-MM-DDTHH:mm:ss"),
                oloc_id: selectedOffice || undefined,
                program_id: selectedProgram || undefined
            },
        });

        let rows = customerNotesData.data.map((data, idx) => {
            const shouldShowFields = data.proj_id
                ? data.proj_id === data.pro_id
                : true;

            let customerNotesData = {
                id: idx,
                emp_id: shouldShowFields ? data.emp_id : null,
                emp_name: shouldShowFields ? (data.emp_first_name ? data.emp_first_name + ' ' + data.emp_last_name : null) : null,
                pro_id: data.pro_id,
                pro_title: data.pro_title,
                cus_name: data.cus_name,
                comment_id: shouldShowFields ? data.comment_id : null,
                cus_comments: shouldShowFields
                    ? isJSON(data.comment_text)
                        ? JSON.parse(data.comment_text)?.blocks.map(block => block.text).join(' ')
                        : data.comment_text
                    : null,
                tas_id: shouldShowFields ? data.task_id : null,
                tas_title: data.tas_title,
                tas_date: data.empLocdate ? moment(data.empLocdate).format('MM/DD/YYYY') : '',
                taskDuration: data.taskDuration,
            };
            return customerNotesData;
        });

        setCustomerNotesData(rows);
        setIsLoading(false);
    };

    const columns = [
        { field: "id", headerName: "ID", width: 100 },
        { field: "cus_name", headerName: "Customer Name", width: 150 },
        { field: "emp_id", headerName: "Employee ID", width: 100 },
        { field: "emp_name", headerName: "Case Manager Name", width: 150 },
        { field: "pro_id", headerName: "Case ID", width: 100 },
        { field: "pro_title", headerName: "Case Name", width: 100 },
        { field: "tas_id", headerName: "Task ID", width: 100 },
        { field: "tas_title", headerName: "Task Title", width: 200 },
        { field: "tas_date", headerName: "Task Date", width: 100 },
        {
            field: "taskDuration",
            width: 75,
            renderHeader: (params) => {
                return (
                    <div
                        style={{
                            maxHeight: "inherit",
                            width: "100%",
                            whiteSpace: "initial",
                            lineHeight: "16px",
                            verticalAlign: "bottom",
                        }}
                    >
                        Duration (Hours)
                    </div>
                );
            },
        },
        { field: "comment_id", headerName: "Comment ID", width: 100 },
        {
            field: "cus_comments",
            headerName: "Notes",
            width: 800,
            flex: 1,
            renderCell: (params) => (
                <div style={{
                    whiteSpace: 'normal',
                    wordWrap: 'break-word',
                    overflowWrap: 'break-word',
                    minHeight: '24px',
                    width: '100%',
                    lineHeight: '1.5',
                    padding: '5px',
                    boxSizing: 'border-box',
                }}>
                    {params.value}
                </div>
            )
        },
    ];

    const isJSON = (str) => {
        try {
            JSON.parse(str);
            return true;
        } catch (e) {
            return false;
        }
    }



    const markFavourite = async (data, type) => {
        const payload = {
            report_id: data?.report_id,
            status: type,
            empID: props.user.emp_id
        };

        axios
            .put(APIURL + "/jsreport/markFavorite", payload)
            .then((response) => {
                if (response?.status === 200 && response?.data?.code === 200) {
                    setSuccessText(response?.data?.status_message || "Favorite Modifed Succesfully");
                } else {
                    setErrorText("Something went wrong");
                }

                fetchData();
            });
    }

    return (
        <div style={{ margin: 0, width: '100%', padding: 10, boxSizing: 'border-box' }}>
            <div style={{ display: "flex", justifyContent: 'space-between' }}>
                <ReportFilterBar onSearch={() => fetchData()} style={{ marginBottom: 10 }}>
                    <LocalizationProvider
                        dateAdapter={AdapterDayjs}
                        localeText={{ start: "From Date", end: "To Date" }}
                    >
                        <DateRangePicker
                            label='Date Range'
                            value={[
                                startDate ? dayjs(startDate) : null,
                                endDate ? dayjs(endDate) : null,
                            ]}
                            onChange={(newValue) => {
                                setStartDate(newValue[0] ? new Date(newValue[0]) : null);
                                setEndDate(newValue[1] ? new Date(newValue[1]) : null);
                            }}
                            slotProps={{ fieldSeparator: { children: 'to' }, textField: { size: 'small' } }}
                        />
                    </LocalizationProvider>

                    <OfficeLocationFilter
                        comp_id={props.comp_id}
                        value={selectedOffice}
                        onChange={setSelectedOffice}
                    />

                    <ProgramFilter
                        comp_id={props.comp_id}
                        value={selectedProgram}
                        onChange={setSelectedProgram}
                    />
                </ReportFilterBar>
                <div>
                    <Tooltip title={isFavorite ? "Remove from favorite reports" : "Add to favorite reports"}>
                        <img
                            src={isFavorite ? "./star-solid.svg" : "./star-regular.svg"}
                            alt="barchart"
                            style={{
                                fontFamily: "Lato",
                                width: "1.5rem",
                                height: "1.5rem",
                                cursor: "pointer",
                                margin: 5
                            }}
                            onClick={() => markFavourite(reportDetails, isFavorite ? 0 : 1)}
                        />
                    </Tooltip>
                </div>
            </div>
            <div style={{ height: 'calc(100vh - 250px)' }}>
                <ControlledDataGrid
                    apiRef={apiRef}
                    gridId={gridId}
                    user={props.user}
                    initialState={{ sorting: { sortModel: [{ field: "cus_name", sort: "asc" }] } }}
                    getRowId={(row) => row.id}
                    rows={customerNotesData}
                    columns={columns}
                    showToolbar
                    checkboxSelection={false}
                    disableRowSelectionOnClick
                    getRowHeight={() => 'auto'}
                    sx={{
                        '& .MuiDataGrid-row:nth-of-type(even)': {
                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                        },
                        '& .MuiDataGrid-row:nth-of-type(odd)': {
                            backgroundColor: 'white',
                        },
                        '& .MuiDataGrid-cell': {
                            whiteSpace: 'normal',
                            lineHeight: 'normal',
                            display: 'flex',
                            alignItems: 'center',
                            paddingTop: '8px',
                            paddingBottom: '8px',
                        },
                    }}
                    loading={isLoading}
                />
            </div>
            <Snackbar
                open={successText !== ""}
                autoHideDuration={30000}
                onClose={() => setSuccessText("")}
            >
                <Alert
                    sx={{ width: "100%" }}
                    severity={"success"}
                    elevation={6}
                    variant="filled"
                >
                    {successText}
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        sx={{ p: 0.25 }}
                        onClick={() => setSuccessText("")}
                    >
                        <CloseIcon />
                    </IconButton>
                </Alert>
            </Snackbar>
            <Snackbar
                open={errorText !== ""}
                autoHideDuration={30000}
                onClose={() => setErrorText("")}
            >
                <Alert
                    sx={{ width: "100%" }}
                    severity={"error"}
                    elevation={6}
                    variant="filled"
                >
                    {errorText}
                    <IconButton
                        aria-label="close"
                        color="inherit"
                        sx={{ p: 0.25 }}
                        onClick={() => setErrorText("")}
                    >
                        <CloseIcon />
                    </IconButton>
                </Alert>
            </Snackbar>
        </div >
    );
};